import { createApi } from '@reduxjs/toolkit/query/react'

import { FeatureType } from 'clickNgo/configs/feature'
import { transformToProcedurePayload } from 'clickNgo/helpers/api'
import { axiosProcedureQuery } from 'clickNgo/helpers/api/axiosProcedureQuery'
import { IForm } from 'core-components/classes/models/IForm'

import { PartnerSpecialization } from '../../models/specialization'

import { mapPartnerSpecializationFromRawData } from './mapping'

type PartnerSpecializationsParams = {
  partnerId: string
  isMember?: 1 | 0
  isCompleted?: 1 | 0
}

export const partnerSpecializationApi = createApi({
  reducerPath: `${FeatureType.CngApi}/partner/specialization`,
  baseQuery: axiosProcedureQuery<IForm[]>(),
  endpoints(build) {
    return {
      partnerSpecializationList: build.query<
        { items: PartnerSpecialization[]; total: number },
        PartnerSpecializationsParams
      >({
        transformResponse(response) {
          return {
            items: response.Data.map(mapPartnerSpecializationFromRawData),
            total: response.Total,
          }
        },

        query(params) {
          return {
            url: `/webservice/197/sp/v4/spLutPartnerSpecializationListGet/call`,
            method: 'POST',
            data: {
              ...transformToProcedurePayload(params),
            },
          }
        },
      }),
    }
  },
})

export const { usePartnerSpecializationListQuery } = partnerSpecializationApi
